'use client';
import React, { useEffect } from 'react';
import { SideModal } from '@/components//ui/side-modal/side-modal';
import { SideModalBody } from '@/components/ui/side-modal/side-modal-body';
import UserProfile from '@/components/user-profile/user-profile';
import LoginRegister from '@/components/user-profile/login-register';
import CloseIcon from '@/assets/icons/close.svg';
import { useIsMobile } from '@/hooks/use-is-mobile';

interface ProfileSliderProps {
  isOpen: boolean;
  onClose: () => void;
  isLoggedIn: boolean;
  user: any;
  node_locale: string;
  brandId: string;
  config: any;
  current_path?: string;
}

export const ProfileSlider = ({
  isOpen,
  onClose,
  isLoggedIn,
  user,
  node_locale,
  brandId,
  config,
  current_path,
}: ProfileSliderProps) => {
  const isMobile = useIsMobile();

  useEffect(() => {
    isOpen
      ? document.body.classList.add('backdrop')
      : document.body.classList.remove('backdrop');
  }, [isOpen]);

  if (!isOpen) return null;

  const content = isLoggedIn ? (
    <UserProfile
      user={user}
      node_locale={node_locale}
      brandId={brandId}
      config={config}
    />
  ) : (
    <LoginRegister
      node_locale={node_locale}
      brandId={brandId}
      config={config}
      handleClose={onClose}
      current_path={current_path}
    />
  );

  if (isMobile) {
    return (
      <>
        <div className="fixed inset-0 z-40 bg-black/50"></div>
        <div className="fixed bg-none !h-auto bottom-0 left-0 z-50 -mb-5 ml-[50%] w-screen -translate-x-1/2 rounded-t-xxl bg-brand-white shadow-default transition-all duration-300 ease-out lg:bottom-auto lg:top-0 lg:mb-auto lg:ml-0 lg:max-h-full lg:w-full lg:translate-x-0 lg:animate-fadeIn lg:overflow-y-auto lg:rounded-b-xxl lg:rounded-t-none">
          <button
            className="fixed -top-20 right-4 z-40 grid h-12 w-12 place-items-center rounded-full bg-brand-grey-1 outline-0 transition-all focus:bg-brand-grey-2 focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-4 focus-visible:outline-brand-grey-2 active:bg-brand-grey-2 lg:right-6 lg:top-6 lg:h-15 lg:w-15 lg:bg-brand-yellow-1 lg:hover:bg-accent-primary-dark lg:focus:bg-accent-primary-dark lg:active:bg-accent-primary-dark"
            onClick={onClose}
            aria-label="Close"
          >
            <CloseIcon />
            <span className="sr-only">Close</span>
          </button>
          <div className="mx-8">{content}</div>
        </div>
      </>
    );
  }

  return (
    <SideModal isOpen={isOpen} handleClose={onClose}>
      <SideModalBody bodyClass="h-full !my-0 !py-16">{content}</SideModalBody>
    </SideModal>
  );
};
